import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/home.vue'
import PackagesView from '../views/Packages.vue'
import BuyPackagesView from '../views/buyPakage.vue'
import LoginView from '../views/auth/login.vue'
import DashboardView from '../views/dashboard/index.vue'
import DashboardProfileView from '../views/dashboard/profile.vue'
import DashboardExercisesView from '../views/dashboard/exercises_composition.vue'
import DashboardHistoryView from '../views/dashboard/history.vue'
import ExerciceView from '../views/dashboard/exercice.vue'
import ExerciceTrainingView from '../views/dashboard/exercice_training.vue'
import ExerciceResults from '../views/dashboard/exercice_results.vue'
import { useAuthStore } from '@/stores/auth'
import Methodologie from '@/views/dashboard/Methodologie.vue'
import checkout from '@/views/checkout.vue'
import ResetPasswordView from '@/views/auth/ResetPassword.vue'


const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomeView,
    },
    {
      path: '/packages',
      name: 'packages',
      component: PackagesView,
    },
    {
      path: '/buy-package/:package_slug/:promo_code?',
      name: 'buy-packages',
      component: BuyPackagesView,
    },
    {
      path: '/checkout/success',
      name: 'checkout-success',
      component: checkout,
    },
    {
      path: '/checkout/error',
      name: 'checkout-error',
      component: checkout,
    },
    {
      path: '/login',
      name: 'login',
      component: LoginView,
      meta: { requiresAuth: false},
    },
    {
      path: '/password-reset-confirm/:first/:token',
      name: 'reset-password',
      component: ResetPasswordView,
      meta: { requiresAuth: false, redirectIfAuthenticated: true },
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      // component: DashboardView,
      children: [
        {
          path: '',
          name: 'dashboard-index',
          component: DashboardView,
          meta: { requiresAuth: true },
        },
        {
          path: 'profile',
          name: 'dashboard-profile',
          component: DashboardProfileView,
          meta: { requiresAuth: true },
        },
        {
          path: 'history',
          name: 'dashboard-history',
          component: DashboardHistoryView,
          meta: { requiresAuth: true },
        },
        {
          path: 'exercises',
          name: 'dashboard-exercises',
          component: DashboardExercisesView,
        },
        {
          path: 'exercises/:examTypeSlug',
          name: 'dashboard-exercises-ExamType',
          component: DashboardExercisesView,
        },
        {
          path: 'exercises/:examTypeSlug/:examSlug/:practice?',
          name: 'dashboard-exercises-Exam',
          component: DashboardExercisesView,
        },
        // {
        //   path: 'exercises/:examTypeSlug/:examSlug/:pratice',
        //   name: 'dashboard-exercises-Exam',
        //   component: DashboardExercisesView,
        // },
        {
          path: '/exercice/:slug',
          name: 'exercice',
          component: ExerciceView,
          props: true,
        },
        {
          path: '/exercice-training/:slug_exam',
          name: 'exercice-training',
          component: ExerciceTrainingView,
          props: true,
        },
        {
          path: '/exercice-results/:slug',
          name: 'ExerciceResults',
          component: ExerciceResults,
          props: true,
        },
        {
          path: '/methodologie',
          name: 'methodologie',
          component: Methodologie,
        },
        {
          path: '/methodologie/:module',
          name: 'methodologie-module',
          component: Methodologie,
        },
        {
          path: '/methodologie/:module/:lesson',
          name: 'methodologie-lesson',
          component: Methodologie,
        },
      ],
    },
    {
      path: '/:catchAll(.*)',
      name: 'NotFound',
      component: () => import('@/views/common/404.vue'),
    },
    {
      path: '/maintenance',
      name: 'maintenance',
      component: () => import('@/views/common/maintenance.vue'),
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth',
      }
    }
    return {
      top: 0,
      behavior: 'smooth',
    }
  },
})

router.beforeEach((to, from, next) => {
  const authStore = useAuthStore()
  const isAuthenticated = authStore.isAuthenticated

  if (to.meta.redirectIfAuthenticated && isAuthenticated) {
    next({ name: 'dashboard' })
  } else if (to.meta.requiresAuth && !isAuthenticated) {
    next({ name: 'login' })
  } else {
    next()
  }
})

export default router
